import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import { getVendorInvoiceSummary } from "../../modules/fiscalUpgrade/services/Invoices/Vendor/VenodrInvoiceSummaryService";

export interface SingleInvoice {
  id: number;
  amount: number;
  vendorName: string;
}

export interface InvoiceState {
  loading: boolean;
  invoices: SingleInvoice[];
  totalRecordCount: number;
  assignedTo: string;
  invoiceId: string;
  error: string | null;
  selectedFiles: any [];
  taskId:number;
  taskSummaryNav:string;
}


const initialState: InvoiceState = {
  loading: false,
  invoices: [],
  totalRecordCount: 0,
  assignedTo: "",
  invoiceId : "",
  error: null,
  selectedFiles: [] as File[],
  taskId: 0,
  taskSummaryNav:""
};


export const fetchVendorInvoiceTask = createAsyncThunk(
  'vendorInvoice/fetchVendorInvoices',
  async (
    { page, rowsPerPage }: { page: number; rowsPerPage: number },
    thunkAPI
  ) => {
    const filter = {
      page: 1,  // ? you might want to pass `page` and `rowsPerPage` here instead of hardcoding
      size: 5,
    };
    try {
      const response = await getVendorInvoiceSummary({ filter });
      return response.data; // expecting { message, data, totalRecordCount, assignedTo }
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

const vendorInvoiceTaskSlice = createSlice({
  name: 'vendorInvoiceTask',
  initialState,
  reducers: {
    setCreateInvoiceTask: (state, action: PayloadAction<Partial<InvoiceState>>) => {
      return { ...state, ...action.payload };
    },
    removeMakePayment: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchVendorInvoiceTask.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchVendorInvoiceTask.fulfilled, (state, action) => {
        state.loading = false;
        state.invoices = action.payload.data;
        state.totalRecordCount = action.payload.totalRecordCount;
        state.assignedTo = action.payload.assignedTo;
      })
      .addCase(fetchVendorInvoiceTask.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  },
});

export const { setCreateInvoiceTask } = vendorInvoiceTaskSlice.actions;
export default vendorInvoiceTaskSlice.reducer;
